import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { message } from 'antd';
import AccountMenu from './AccountMenu';
import { wishlistApi } from '../../api/Api';
import './WishlistTheme.css';
import WishlistRemovalDialog from './WishlistRemovalDialog';

class Wishlist extends Component {
    state = { wishlist: [], loading: true, loadError: false, removingSku: null, removeCandidate: null };

    componentDidMount() { this.loadWishList(); }

    loadWishList = async () => {
        this.setState({ loading: true, loadError:false });
        try {
            const response = await wishlistApi.list();
            this.setState({ wishlist: response.data?.data || [] });
        } catch (error) {
            this.setState({loadError:true});
            message.error({ content: 'Unable to load your wishlist.', className: 'notificationBox' });
        } finally { this.setState({ loading: false }); }
    };

    removeItem = async (productSkuId) => {
        if (this.state.removingSku !== null) return;
        this.setState({ removingSku: productSkuId });
        try {
            await wishlistApi.remove(productSkuId);
            this.setState((state) => ({ wishlist: state.wishlist.filter((item) => Number(item.product_sku_id) !== Number(productSkuId)), removeCandidate:null }));
            message.success({ content: 'Removed from wishlist.', className: 'notificationBox' });
        } catch (error) {
            message.error({ content: 'Unable to remove product from wishlist.', className: 'notificationBox' });
        } finally { this.setState({ removingSku: null }); }
    };

    productLink(item) { return item.product_slug ? `/product/${encodeURIComponent(item.product_slug)}` : `/product/${item.product_id}`; }

    render() {
        const { wishlist, loading, loadError, removingSku, removeCandidate } = this.state;
        return (
            <div className="ps-account-page ps-account-page--profile nw-account nw-wishlist">
                <div className="ps-categogy ps-categogy--separate ps-account-shell"><div className="container whiteContainer ps-account-shell__container"><div className="ps-account-shell__layout">
                    <AccountMenu />
                    <main className="ps-account-shell__content">
                        <nav aria-label="Breadcrumb"><ul className="ps-breadcrumb ps-account-shell__breadcrumb"><li className="ps-breadcrumb__item"><Link to="/">Home</Link></li><li className="ps-breadcrumb__item"><Link to="/account">My account</Link></li><li className="ps-breadcrumb__item" aria-current="page">Wishlist</li></ul></nav>
                        <header className="nw-wishlist__header">
                            <div><h1>My <span>wishlist</span></h1><p>Your favourites, saved for another day.</p></div>
                            <Link className="nw-wishlist__browse" to="/">Continue shopping <span aria-hidden="true">→</span></Link>
                        </header>
                        {loading ? <div className="nw-wishlist__list" role="status" aria-label="Loading wishlist" aria-busy="true">{[1,2,3,4].map(id => <div className="nw-wishlist__skeleton" key={id} aria-hidden="true"><div/><span/><span/><span/></div>)}</div>
                        : loadError ? <section className="nw-wishlist__empty" role="alert"><h2>We couldn’t load your wishlist</h2><p>Please try again to see your saved products.</p><button type="button" className="nw-account__button" onClick={this.loadWishList}>Try again</button></section>
                        : wishlist.length > 0 ? <>
                            <div className="nw-wishlist__list-heading"><h2>Saved favourites</h2><span>{wishlist.length} {wishlist.length === 1 ? 'item' : 'items'}</span></div>
                            <div className="nw-wishlist__list">{wishlist.map(item => {
                                const name = item.product_name || 'Product';
                                const price = Number(item.offer_price);
                                const mrp = Number(item.mrp);
                                const discounted = Number.isFinite(price) && price >= 0 && mrp > price;
                                const discount = discounted ? Math.round((mrp - price) / mrp * 100) : 0;
                                return <article className="nw-wishlist-card" key={item.product_sku_id} aria-label={name}>
                                    <div className="nw-wishlist-card__media">
                                        <Link className="nw-wishlist-card__image" to={this.productLink(item)}><img src={item.display_image || '/assets/img/logo-no-image.png'} alt={name} loading="lazy" onError={event => {if (!event.currentTarget.dataset.fallback) {event.currentTarget.dataset.fallback = 'true'; event.currentTarget.src = '/assets/img/logo-no-image.png';}}}/></Link>
                                    </div>
                                    <div className="nw-wishlist-card__content">
                                        <h3><Link to={this.productLink(item)} title={name}>{name}</Link></h3>
                                        {discount > 0 && <span className="nw-wishlist-card__offer">{discount}% off</span>}
                                    </div>
                                    <div className="nw-wishlist-card__price"><strong>{Number.isFinite(price) ? `₹${price.toFixed(2)}` : 'Price unavailable'}</strong>{discounted && <del aria-label={`MRP ₹${mrp.toFixed(2)}`}>₹{mrp.toFixed(2)}</del>}</div>
                                    <div className="nw-wishlist-card__actions">
                                        <Link className="nw-account__button nw-wishlist-card__add" to={this.productLink(item)} aria-label={`Select options for ${name}`} title="Choose a variant and check availability">
                                            Select options
                                        </Link>
                                        <button type="button" className="nw-wishlist-card__remove" onClick={() => this.setState({removeCandidate:item})} disabled={removingSku !== null} aria-label={`Remove ${name}`} title="Remove from wishlist" aria-busy={removingSku === item.product_sku_id}>
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v5M14 11v5"/></svg>
                                        </button>
                                    </div>
                                </article>;
                            })}</div>
                        </> : <section className="nw-wishlist__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" aria-hidden="true"><path d="M20.5 5.5a5 5 0 0 0-7 0L12 7l-1.5-1.5a5 5 0 0 0-7 7L12 21l8.5-8.5a5 5 0 0 0 0-7Z"/></svg><h2>A little room for your favourites</h2><p>Tap the heart on any product to save it here for later.</p><Link to="/" className="nw-account__button">Explore products</Link></section>}
                    </main>
                </div></div></div>
                {removeCandidate && <WishlistRemovalDialog
                    name={removeCandidate.product_name || 'this product'}
                    busy={removingSku !== null}
                    onCancel={() => this.setState({removeCandidate:null})}
                    onConfirm={() => this.removeItem(removeCandidate.product_sku_id)}
                />}
            </div>
        );
    }
}

export default Wishlist;
